import React from "react";
import ShopFilters from "./../shop/ShopFilters";
import ShopItems from "../shop/ShopItems";
import InfluencersCircles from "../../components/InfluencersCircles";
import Container from "../../components/Container";
import { useEffect } from "react";
import { scrollTo } from "../../assets/js/helpers";

const InfluencerProductsTab = () => {
  useEffect(() => {
    scrollTo();
  }, []);

  return (
    <>
      <section className="bg-white">
        <Container display={"flex"} width={"w-full"}>
          <div className="w-3/12 xs:hidden lg:block">
            <ShopFilters />
          </div>
          <div className="xs:w-full lg:w-9/12">
            <ShopItems />
          </div>
        </Container>
      </section>
      <section>
        <Container maxWidth={"max-w-full"} width="w-full">
          <InfluencersCircles />
        </Container>
      </section>
    </>
  );
};

export default InfluencerProductsTab;
